export const LOGIN_USER = 'LOGIN_USER';
export const LOGOUT_USER = 'LOGOUT_USER';
export const UPDATE_USER_DETAILS = 'UPDATE_USER_DETAILS';
export const SHOW_LOADER = 'SHOW_LOADER';
